module.exports = __webpack_public_path__ + "img/foot.9e27f384.png";